import routes from './errors.routes';

export const errorsModule = {
    routes
};